export enum EUploadingStatus {
  UPLOADING = 'UPLOADING',
  DONE = 'DONE',
  ERROR = 'ERROR',
  ERROR_ATTACHED = 'ERROR_ATTACHED',
}
